// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkComponent_link__249Fm"};